import product1 from "../../../assets/images/beautytreasure/product-1.png";
import product2 from "../../../assets/images/beautytreasure/product-2.png";
import product3 from "../../../assets/images/beautytreasure/product-3.png";
import product4 from "../../../assets/images/beautytreasure/product-4.png";

import logo from "../../../assets/images/beautytreasure/logo.png";
import logo1 from "../../../assets/images/beautytreasure/logo-1.png";
import logo2 from "../../../assets/images/beautytreasure/logo-2.png";
export const banner = {
  text: "Beauty Treasures Distribution",
  img: product1,
};

export const products = [
  {
    title: "Beauty Treasures",
    description:
      "Beauty Treasures Boutique is a paradise for shoppers who love luxury brands from Global Leading Brand",
    link: "https://beautytreasuresdistribution.com/",
    img: product4,
  },
  {
    title: "Uriage",
    description:
      "The Protective Force of the Alps Water for My Skin.💧  Reinforces your skin barrier ✅  Recommended by doctors & dermatologists ✅ Suitable for all skin types ✅ ",
    link: "https://uriage.pitiplus.app/",
    img: product2,
  },
  {
    title: "Filorga",
    description: "Skincare Products· Beauty/Cosmetics company · Medi Cosmetics",
    link: "https://filorga.pitiplus.app/",
    img: product3,
  },
];

export const logos = [
  {
    url: logo1,
    alt: "filorga",
    link: "https://filorga.pitiplus.app/",
  },
  {
    url: logo,
    alt: "beauty treasure",
    link: "https://beautytreasuresdistribution.com/",
  },
  {
    url: logo2,
    alt: "uriage",
    link: "https://uriage.pitiplus.app/",
  },
];
